import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const listSprints = async (
  companyId: string,
  companyType: string,
  projectId: number,
  state?: string
) =>
  post("projectService/sprint/listSprints", {
    company_id: companyId,
    company_type: companyType,
    project_id: projectId,
    state,
  });

export const getSprintById = async (
  companyId: string,
  companyType: string,
  sprintId: number
) =>
  post("projectService/sprint/getSprintById", {
    company_id: companyId,
    company_type: companyType,
    id: sprintId,
  });

export const createSprint = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/sprint/createSprint", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const updateSprint = async (
  companyId: string,
  companyType: string,
  sprintId: number,
  payload: Record<string, any>
) =>
  post("projectService/sprint/updateSprint", {
    company_id: companyId,
    company_type: companyType,
    id: sprintId,
    ...payload,
  });

export const deleteSprint = async (
  companyId: string,
  companyType: string,
  sprintId: number
) =>
  post("projectService/sprint/deleteSprint", {
    company_id: companyId,
    company_type: companyType,
    id: sprintId,
  });

export const startSprint = async (
  companyId: string,
  companyType: string,
  sprintId: number
) =>
  post("projectService/sprint/startSprint", {
    company_id: companyId,
    company_type: companyType,
    id: sprintId,
  });

export const completeSprint = async (
  companyId: string,
  companyType: string,
  sprintId: number,
  moveUnfinishedTo: "BACKLOG" | number
) =>
  post("projectService/sprint/completeSprint", {
    company_id: companyId,
    company_type: companyType,
    id: sprintId,
    move_unfinished_to: moveUnfinishedTo,
  });

export const reorderSprints = async (
  companyId: string,
  companyType: string,
  sprintIds: number[]
) =>
  post("projectService/sprint/reorderSprints", {
    company_id: companyId,
    company_type: companyType,
    sprint_ids: sprintIds,
  });
